/** @jsxImportSource @emotion/react */

import { mobileCockFightingUPDATE } from "assets/common/images/game/mobile/cock-fighting";
import { NotiMarque } from "components/desktop/NotiMarque";
import CategoryGameSwiper from "components/mobile/CategoryGameSwiper";
import FuncUser from "components/mobile/FuncUser";
import { dataLotteryMobile } from "contants/game/mobile/contents/lottery";
import handleLoginGame from "helpers/handleLoginGame";
import { useAppDispatch } from "hooks/app-hook";
import { SwiperBanner } from "pages/desktop/HomePage/SwiperBanner/SwiperPagination";
import { useSelector } from "react-redux";
import { selectUsername } from "store/auth";

import { LotteryMobileStyle } from "./style.index";

const LotteryMobile = () => {
  const username = useSelector(selectUsername);
  const dispatch = useAppDispatch();
  return (
    <div css={LotteryMobileStyle.wrapper}>
      <NotiMarque />
      <SwiperBanner />
      <FuncUser />
      <CategoryGameSwiper />

      <div css={LotteryMobileStyle.mainContent}>
        {dataLotteryMobile.map((items, index) => (
          <div
            onClick={() => {
              handleLoginGame(items, username, dispatch);
            }}
            key={index}
            css={LotteryMobileStyle.item}
          >
            <img src={items.picture} alt="" />
            <span>{items.name}</span>
          </div>
        ))}
        <div css={LotteryMobileStyle.item}>
          <img src={mobileCockFightingUPDATE} alt="" />
          <span>updating...</span>
        </div>
      </div>
    </div>
  );
};

export default LotteryMobile;
